import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, error, "aria-describedby": ariaDescribedBy, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm min-h-[44px]",
        error && "border-red-500 focus-visible:ring-red-500",
        className
      )}
      ref={ref}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={ariaDescribedBy}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
